/* ================================================== */
/* CONTROLLER → Map
/* ================================================== */

var GQ;

app.controller('mapCtrl', ['$scope', '$rootScope', '$timeout', function($scope, $rootScope, $timeout) {

	// Init
	var lang = ($rootScope.lang == 'nl') ? 'MD_NAME_DUT' : 'MD_NAME_FRE';

	// Get GQ
	$rootScope.getGq = function(neighborhoodId) {
		var neighborhoodId = neighborhoodId.toString().replace('{{', '').replace('}}', '');
		angular.forEach(statisticalSectors, function(value, key) {
			var sector = value[0],
				index = value[1];
			if (neighborhoodId == sector) {
				$rootScope.formDataRaw.gq = '{{' + sector + '}}';
			}
		});
	}

	// Has GQ
	$rootScope.hasGq = function(neighborhoodId) {
		var neighborhoodId = neighborhoodId.toString().replace('{{', '').replace('}}', '');
		var neighborhoodHasGq = false;
		angular.forEach(statisticalSectors, function(value, key) {
			var sector = value[0],
				index = value[1];
			if (neighborhoodId == sector) {
				neighborhoodHasGq = true;
			}
		});
		return neighborhoodHasGq;
	}

	// Is marker inside polygon?
	$rootScope.isMarkerInsidePolygon = function(pointX, pointY) {
		var features = (mapboxglSupported) ? geojson.features : geojsonFeatures;

		if (features.length > 0) {
			for (var i = 0; i < features.length; i++) {
				var pt             = turf.point([pointX, pointY]),
					poly           = features[i],
					isInside       = turf.inside(pt, poly),
					neighborhoodId = poly.properties.INSSEC;

				if (isInside === true) {
					// Get GQ → for calculation
					$scope.getGq(neighborhoodId);

					$rootScope.formDataRaw.neighborhoodId = '{{' + neighborhoodId + '}}';
					neighborhood = (lang == 'nl') ? poly.properties.MD_NAME_DUT : poly.properties.MD_NAME_FRE;
					neighborhood = prepareNeighborhoodName(neighborhood);
					$rootScope.formDataRaw.neighborhood = neighborhood;

					if ($rootScope.formDataRaw.gq !== null){
						if (mapboxglSupported) {

							// Fly to
							map.flyTo({
								center: [pointX, pointY]
							});

							// Highlight polygon
							return $scope.highlightPolygon(pt, poly);

						} else {

							// Save neighborhood name
							neighborhood = prepareNeighborhoodName(poly.properties[lang]);
							$timeout(function() {
								$rootScope.formDataCooked.location = prepareNeighborhoodName(poly.properties[lang]);
							});

							// Fly to
							$timeout(function() {
								map.panTo([pointY, pointX], { animate: true });
							});

							// Highlight polygon
							return $scope.highlightPolygon(pointX, pointY);

						}
					}

				}
			}
		}
	}

	// Highlight polygon
	$scope.highlightPolygon = function(pt, poly) {
		if (poly !== lastPoly) {

			if (mapboxglSupported) {

				var point         = map.project(pt.geometry.coordinates),
					features      = map.queryRenderedFeatures(point, { layers: ['neighborhoods'] }),
					featuresLayer = map.queryRenderedFeatures(point, { filter: ['has', 'INSSEC'] });

				// Set initial fill-color to prev feature
				$scope.checkLayoutVisibility(featuresId);

				// Set current feature vars
				if (featuresLayer.length > 0) {

					// Init
					featuresId = featuresLayer[0].layer.id;
					lastPoly   = poly;

					// Remove GQ
					$scope.checkLayoutVisibility(featuresId);

					// Send neighborhood name to address field
					neighborhood = prepareNeighborhoodName(featuresLayer[0].properties[lang]);

				}

				// Set new active neighborhood
				map.getSource('neighborhoodsActiveSrc').setData({
					'type': 'FeatureCollection',
					'features': features.map(function(f) {
						return {
							'type': 'Feature',
							'geometry': f.geometry
						};
					})
				});
				map.setLayoutProperty('neighborhoods-fills-active', 'visibility', 'visible');

			} else {

				// Check if coordinates are within layer
				var pointX  = pt,
					pointY  = poly;
				newSelected = leafletPip.pointInLayer([pointX, pointY], neighborhoodLayer, true);

				if (newSelected.length > 0) {

					// Reset selected neighborhood styles
					neighborhoodLayer.eachLayer(function(layer) {
						if (layer == selected) {
							return neighborhoodLayer.resetStyle(layer);
						}
					});

					// Set new active neighborhood
					selected = newSelected[0];
					lastPoly = poly;

					// Set selected neighborhood styles
					selected.setStyle({
						color       : 'transparent',
						fillColor   : 'rgb(253, 120, 42)',
						weight      : 0,
						fillOpacity : 0.5
					});

				}

			}

		}
	}

	// CheckLayout visibility
	$scope.checkLayoutVisibility = function(featuresId) {
		if (featuresId !== null && featuresId !== 'neighborhoods' && featuresId !== 'neighborhoods-fills-hover' && featuresId !== 'neighborhoods-fills-active') {
			var visibility = map.getLayoutProperty(featuresId, 'visibility');

			if (visibility === 'visible') {
				map.setLayoutProperty(featuresId, 'visibility', 'none');
			} else {
				map.setLayoutProperty(featuresId, 'visibility', 'visible');
			}
		}
	}

}]);